import {Component, OnDestroy, OnInit} from '@angular/core';
import {Login} from '../model/Login';
import {AuthenticationService} from '../../shared/Services/authentication.service';
import {Router} from '@angular/router';
import {Role} from '../../shared/Models/Role';
import {TranslateService} from '@ngx-translate/core';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { Helper } from 'src/app/helpers/helper.service';
import { StorageService } from '../storage.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  public login: Login = new Login();
  public isSubmitting = false;
  public twoFactorStep = false;

  constructor(
    private auth: AuthenticationService,
    private router: Router,
    private translateService: TranslateService,
    private reCaptchaV3Service: ReCaptchaV3Service,
    private helper: Helper,
    private storageService: StorageService
  ) {
  }

  ngOnInit() {
    localStorage.clear();
    if (this.auth.isLoggedIn()) {
      this.auth.getProfile().subscribe((result) => {
        switch (result.roles[0]) {
          case Role.ROLE_BACK_OFFICE:
            this.router.navigateByUrl('/back-office/dashboard');
            break;
          case Role.ROLE_DEALER:
            if (this.auth.isDealerTabletUser()) {
              this.router.navigateByUrl('/dealer-system/quote/overview');
            } else {
              this.router.navigateByUrl('/dealer-system/dashboard');
            }
            break;
        }
      });
    }
    document.querySelector('body').setAttribute('themebg-pattern', 'theme1');

    this.helper.removeHideRecaptchaBadgeClassToBody();
  }

  submitLogin() {
    this.isSubmitting = true;
    this.reCaptchaV3Service.execute('login').subscribe((token: string) => {
      this.login.recaptchaToken = token;
      this.storageService.setData(this.login);
      this.auth.login(this.login).subscribe((result) => {
        this.isSubmitting = false;
        if ( result['2faIsActivated']) {
          this.router.navigate(['/verify-code']);
        } else {
        this.translateService.use(this.auth.getLocale());
        switch (result.roles[0]) {
          case Role.ROLE_BACK_OFFICE:
            this.router.navigateByUrl('/back-office/dashboard');
            break;
          case Role.ROLE_DEALER:
            this.router.navigateByUrl('/dealer-system/dashboard');
            break;
        }}
      }, () => {
        this.isSubmitting = false;
      });
    }, () => {
      this.isSubmitting = false;
      this.helper.popMessageDialog(
        this.translateService.instant('errors.recaptcha.title'),
        this.translateService.instant('errors.recaptcha.failed'),
        'error',
        false,
      );
    });
  }

  ngOnDestroy(): void {
    this.helper.addHideRecaptchaBadgeClassToBody();
  }
}
